import Chronometer from 'app/components/Chronometer'

export default ({ prefix, dodoable }) => {
  return (
    <Link to={`/dodoables/${dodoable.id}`} className={`dodoable-list-item`}>
      <div className="dodoable-list-item-content">
        {prefix ? (
          <div className="dodoable-list-item-content-prefix"> {prefix} </div>
        ) : null}
        <div className="dodoable-list-item-text"> {dodoable.name} </div>
      </div>
      <div className="dodoable-list-item-icon-wrapper">
        <i className="dodoable-list-item-icon"></i>
      </div>
    </Link>
  )
}
